<!--  BEGIN CONTENT PART  -->
<div id="content" class="main-content">
    <div class="container">
        <div class="page-header">
            <div class="page-title">
                <h2><b>Comptes Entreprises</b></h2>
            </div>
        </div>
        <div *ngIf="loading_accounts" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
            margin-bottom: 15%;"></div>
        <div *ngIf="!loading_accounts">
            <div class="accordion d-none" id="accordionExample" style="background: none;">
                <div class="card" style="background: none;">
                  <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                      <button class="btn btn-link btn-primary image.png" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        Recherche Avancée
                      </button>
                    </h2>
                  </div>
              
                  <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body">
                        <form [formGroup]="advancedSearchForm">
                            <div class="row">
                                <div class="col">
                                    <div class="row">
                                        <div class="col-lg-3 col-md-4 margin-bottom-20 country-search">
                                            <div class="form-group text-left mb-0">
                                                <label class="control-label text-black text-left" for="customers">Client </label>
                                            </div>
                    
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <div class="form-inline my-2 my-lg-0">
                                                        <input type="text" class="form-control br-30 w-100" id="customers" placeholder="Saisir le client ..."
                                                            (keyup)="onKeyUp($event,'customer')">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-4 country-search">
                                            <div class="form-group text-left mb-0">
                                                <label class="control-label text-black text-left" for="commercials">Commercial  </label>
                                            </div>
                    
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <div class="form-inline my-2 my-lg-0">
                                                        <input type="text" class="form-control br-30 w-100" id="commercials" placeholder="Saisir le commercial ..."
                                                            (keyup)="onKeyUp($event,'commercial')">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-4 country-search">
                                            <div class="form-group text-left mb-0">
                                                <label class="control-label text-black text-left" for="country">Secteur d'activité  </label>
                                            </div>
                    
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <div class="form-inline my-2 my-lg-0">
                                                        <input type="text" class="form-control br-30 w-100" id="sectors" placeholder="Saisir le secteur ..."
                                                            (keyup)="onKeyUp($event,'customer_sector')">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-4 country-search" >
                                            <div class="form-group text-left mb-0">
                                                <label class="control-label text-black text-left" for="country">Visite Topic  </label>
                                            </div>
                    
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <div class="form-inline my-2 my-lg-0">
                                                        <input type="text" class="form-control br-30 w-100" id="topics" placeholder="Saisir le Topic ..."
                                                            (keyup)="onKeyUp($event,'visit_topic')">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-4 margin-bottom-20 country-search">
                                            <div class="form-group text-left mb-0">
                                                <label class="control-label text-black text-left" for="country">Ville  </label>
                                            </div>
                    
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <div class="form-inline my-2 my-lg-0">
                                                        <input type="text" class="form-control br-30 w-100" id="cities" placeholder="Saisir la ville ..."
                                                            (keyup)="onKeyUp($event,'customer_city')">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-4 margin-bottom-20 country-search">
                                            <div class="form-group text-left mb-0">
                                                <label class="control-label text-black text-left" for="type">Type action </label>
                                            </div>
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <div class="form-inline my-2 my-lg-0">
                                                        <select class="form-control br-30 w-100" id="type" formControlName="action_type">
                                                            <option value="">Sélectionnez le type d'action  ...</option>
                                                            <option value="INIT">Action initiale</option>
                                                            <option value="NEW">Action durant la visite</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-4 margin-bottom-20 country-search">
                                            <div class="form-group text-left mb-0">
                                                <label class="control-label text-black text-left" for="actionStatus">Statut action </label>
                                            </div>
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <div class="form-inline my-2 my-lg-0">
                                                        <select class="form-control br-30 w-100" id="actionStatus" formControlName="action_status">
                                                            <option value="">Sélectionnez le statut de l'action ...</option>
                                                            <option value="2">Fait</option>
                                                            <option value="1">En cours</option>
                                                            <option value="0">Non fait</option>
                
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-4 margin-bottom-20 country-search">
                                            <div class="form-group text-left mb-0">
                                                <label class="control-label text-black text-left" for="visitStatus">Statut visite </label>
                                            </div>
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <div class="form-inline my-2 my-lg-0">
                                                        <select class="form-control br-30 w-100" id="visitStatus" formControlName="visit_action_status">
                                                            <option value="">Sélectionnez le statut de la visite ...</option>
                                                            <option value="1">Créée</option>
                                                            <option value="2">Planifiée</option>
                                                            <option value="3">En cours</option>
                                                            <option value="4">Annulée</option>
                                                            <option value="5">Reportée</option>
                                                            <option value="6">Terminée</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-4 margin-bottom-20 country-search">
                                            <div class="form-group text-left mb-0">
                                                <label class="control-label text-black text-left" for="start_date">Du </label>
                                            </div>
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <div class="form-inline my-2 my-lg-0">
                                                        <input class="form-control br-30 w-100" type="date" name="start_date" id="start_date" formControlName="start_date">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                        
                                        <div class="col-lg-3 col-md-4 margin-bottom-20 country-search">
                                            <div class="form-group text-left mb-0">
                                                <label class="control-label text-black text-left" for="end_date">Au </label>
                                            </div>
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <div class="form-inline my-2 my-lg-0">
                                                        <input class="form-control br-30 w-100" type="date" name="end_date" id="end_date" formControlName="end_date">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                  </div>
                </div>
            </div>
            <div class="row" id="cancel-row" *ngIf="!loading_accounts">
                <div class="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                    <div class="statbox widget box box-shadow">
                        <div class="widget-header">
                            <div class="row">       
                            </div>
                        </div>
                        <div class="widget-content widget-content-area">
                            <div class="table-responsive mb-4">
                                <div *ngIf="loading_accounts" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 20%;
                                            margin-bottom: 20%;"></div>
                                <table *ngIf="!loading_accounts" id="alter_paginations" class="table table-striped table-bordered" style="width:100%">
                                    <thead >
                                        <tr>
                                            <th>Raison sociale</th>
                                            <th>Ville</th>
                                            <th>Pack</th>
                                            <th>Date de création</th>
                                            <th>Date de fin d’abonnement</th> 
                                            <th>Nombre utilisateurs</th>
                                            <th>Statut</th>  
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let account of accounts" >
                                            <td>{{account.raison_social}}</td>
                                            <td>{{account.city}}</td>
                                            <td>{{account.pack}}</td>
                                            <td>
                                                <span class="mb-2 ml-2 badge badge-pills badge-success" *ngIf="account.createdAt != null" 
                                                    style="font-size: xx-small;">{{account.createdAt | date: 'yyyy/MM/dd - HH:mm '}}</span>
                                                <span *ngIf="account.createdAt == null"
                                                    style="font-size: xx-small;"> - - - </span>
                                            </td>
                                            <td>
                                                <span class="mb-2 ml-2 badge badge-pills badge-success" *ngIf="account.createdAt != null" 
                                                    style="font-size: xx-small;">{{account.finishedAt | date: 'yyyy/MM/dd - HH:mm '}}</span>
                                                <span *ngIf="account.finishedAt == null"
                                                    style="font-size: xx-small;"> - - - </span>
                                            </td>
                                            <td>{{account.users_total}}</td>
                                            <td>
                                                <div class="text-center">
                                                    <b>
                                                        <span *ngIf="account.status===true" class="text-success">Actif</span>
                                                        <span *ngIf="account.status===false" class="text-primary">Non actif</span>
                                                        <span *ngIf="account.status===null" style="font-size: xx-small;"> - - - </span>
                                                    </b>
                                                </div>
                                            </td> 
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>    
                </div>
            </div>
        </div>
    </div>
</div>
